$('.input-data select').change(function (e) {
    $(this).removeClass('empty_input');
    ($(this).val() !== '' && $(this).val() !== null)
        && $(this).addClass('filled');
});

$('.input-data textarea').change(function (e) {
    $(this).removeClass('empty_input');
});

$('.input-data input').change(function (e) {
    $(this).removeClass('empty_input');
    if ($(this).val().length > 0) {
        $(this).addClass('filled');
    } else {
        $(this).removeClass('filled');
    }
});


const prev_content = () => {
    const active_bullet = $('.bullet.active');
    const active_card = $('.step-content.active');
    const prev_bullet = $(active_bullet).prev();
    const prev_card = $(active_card).prev();
    if (prev_bullet.length > 0) {
        $(active_bullet).removeClass('previous_active');
        $(active_bullet).removeClass('active');
        $(active_card).removeClass('animate__fadeInRight');
        $(active_card).addClass('animate__fadeOutRight');

        $(prev_bullet).addClass('active');
        setTimeout(() => {
            $(active_card).removeClass('active');

            $(prev_card).removeClass('animate__fadeInRight animate__fadeOutLeft');
            $(prev_card).addClass('active animate__fadeInLeft');

            $('html, body').animate({
                scrollTop: 200
            }, 1000);
        }, 470);
    }
}

const next_content = () => {
    const active_bullet = $('.bullet.active');
    const active_card = $('.step-content.active');
    const next_bullet = $(active_bullet).next();
    const next_card = $(active_card).next();
    if (next_bullet.length > 0) {
        $(active_bullet).addClass('previous_active');
        $(active_bullet).removeClass('active');
        $(active_card).removeClass('animate__fadeInRight');
        $(active_card).addClass('animate__fadeOutLeft');

        $(next_bullet).addClass('active');
        setTimeout(() => {
            $(active_card).removeClass('active');

            $(next_card).removeClass('animate__fadeOutRight');
            $(next_card).addClass('active animate__fadeInRight');

            $('html, body').animate({
                scrollTop: 200
            }, 1000);
        }, 470);
    }



}

const send_info = () => {
    let data_fill = $(`form [required="required"]`);
    let bnd = true;
    let indx = 0;
    let msg = '';

    const testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;

    for (let i = 0; i < data_fill.length; i++) {
        if ($(data_fill[i]).val() === '' || $(data_fill[i]).val() === null) {
            bnd = false;
            indx = i;
            break;
        } else {
            if (data_fill[i].type == 'email' && !testEmail.test($(data_fill[i]).val())) {
                msg = 'Incluye correo electrónico valido';
                indx = i;
                bnd = false;
                break;
            }
        }
    }

    if (!bnd) {
        const el_id = data_fill[indx].id;
        const step_content = $(`#${el_id}`).closest('.step-content')[0].id;

        $('li.bullet').removeClass('active previous_active');

        $('.step-content').removeClass('active animate__fadeOutLeft');

        switch (step_content) {
            case 'stepOne':
                $('li.bullet:first-child').addClass('active');
                break;
            case 'stepTwo':
                $('li.bullet:nth-child(2)').addClass('active');
                break;
            default:
                break;
        }

        if (step_content !== 'stepThree') {

            $(`#stepThree`).removeClass('animate__fadeInRight');
            $(`#stepThree`).addClass('animate__fadeOutRight');

            setTimeout(() => {
                $(`#stepThree`).removeClass('active');

                $(`#${step_content}`).removeClass('animate__fadeInRight animate__fadeOutLeft');
                $(`#${step_content}`).addClass('active animate__fadeInLeft');
                $(`#${el_id}`).focus();
            }, 470);
        } else {
            $(`#${el_id}`).focus();
        }
        setTimeout(() => {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            })

            msg = (msg == '') ? 'Llena todos los campos que contengan un "*"' : msg;
            Toast.fire({
                icon: 'warning',
                title: msg
            });
        }, 600);

    } else {
        const nameD = $(`#nameD`).val();
        const emailD = $('#emailD').val();
        const phoneD = $('#phoneD').val();
        const stateD = $('#stateD').val();
        let timeD = "";
        const type_advs = $('#type_advs').val();
        const spaceD = $('#spaceD').val();
        let colors_palet = '';
        let trend = '';
        const measures = $('#measures').val();
        const space_file = $(`#space_file`).prop('files')[0];
        const textareaD = $('#textareaD').val();

        $('input[name="colors_palet"]').each(function (index, element) {
            if ($(element).is(':checked')) colors_palet = $(element).val();

        });

        $('input[name="trend"]').each(function (index, element) {
            if ($(element).is(':checked')) trend = $(element).val();
        });


        if (spaceD != "Hogar particular" && spaceD !== 'Cocina') {
            timeD = $("#timeD").val();
        }

        //Se genera el asunto y el html del correo y se envía mediante ajax
        let subject = "";
        let to = ['disenatuhogar@cantia.mx', 'disenatunegocio@cantia.mx', 'pablo.ramirez@cantia.mx'];
        let business = "";
        if (spaceD === 'Hogar particular') {
            subject = 'Asesoría para el hogar';
        } else if (spaceD === 'Cocina') {
            subject = 'Asesoría para cocina';
            to = ['cocina.aguascalientes@cantia.mx', 'pablo.ramirez@cantia.mx'];
        } else {
            business = '<li>Horario: ' + timeD + '</li>';
            subject = "Asesoría para negocio";
        }
        const textareaD_html = (textareaD != '') ? `<li>Proyecto:   ${textareaD}  </li> ` : '';

        let bodyE =
            `
                Se recibió una nueva asesoría en el sitio con los siguientes datos: 
                <ul>
                    <li>Nombre:  ${nameD}  </li > 
                    <li>Correo electrónico:  ${emailD}  </li > 
                    <li>Teléfono:  ${phoneD}  </li > 
                    <li>Estado de la república:  ${stateD}  </li > 
                    <li>Tipo de asesoria: ${type_advs}</li>
                    <li>Espacio por decorar:  ${spaceD}  </li > 
                    ${business} 
                    <li>Paleta de colores: ${colors_palet}</li>
                    <li>Tendencia: ${trend}</li>
                    <li>Medidas: ${measures}</li>
                    ${textareaD_html}
                </ul > 
                <p class="center" > Si puedes ponerte en contacto con el cliente.<br> 
                ¡Saludos!</p >
            `
            ;

        let msg_html = `
            <h1 class="title">Asesoría de decoración</h1> 
            ${bodyE}

        `;



        let formData = new FormData();

        const from_mail = 'info@cantia.com.mx';
        const from_name = 'Asesoria de decoración';

        //to = ['pablo.ramirez@cantia.mx','rmzpablo80@gmail.com'];

        formData.append('to', to);
        formData.append('from_mail', from_mail);
        formData.append('from_name', from_name);
        formData.append('subject', subject);
        formData.append('msg_html', msg_html);

        const file_name = `${nameD}-${spaceD}`;
        if (typeof space_file != undefined) {
            formData.append('space_file', space_file);
            formData.append('file_name', file_name);
        }

        $('#btn_sender').fadeOut();
        setTimeout(() => {
            $('.btn-cantia').fadeOut();
            $('.snippet').fadeIn();
        }, 250);
        axios.post('https://server-cantia-dot-mx-vianney-001.uc.r.appspot.com/sender', formData)
            .then(function ({ data }) {
                console.log(data);
                if (data.ok) {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'center',
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })


                    Toast.fire({
                        icon: 'success',
                        title: '¡Información enviada!'
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000);
                } else {
                    $('.snippet').fadeOut();
                    setTimeout(() => {
                        $('.btn-cantia').fadeIn();
                        $('#btn_sender').fadeIn();
                    }, 250);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
}
$(document).ready(function () {
    if ($("#spaceD").is(":visible")) {
        $("#spaceD").on("change", () => {
            const sel_op = $("#spaceD").val();
            switch (sel_op) {
                case 'Airbnb':
                    $('#bannerForm').attr('class', 'airbnb');
                    break;
                case 'Casas muestra':
                    $('#bannerForm').attr('class', 'casas-m');
                    break;
                case 'Cocina':
                    $('#bannerForm').attr('class', 'cocina');
                    break;
                case 'Hogar particular':
                    $('#bannerForm').attr('class', 'hogar');
                    break;
                case 'Negocio':
                    $('#bannerForm').attr('class', 'negocio');
                    break;
                case 'Oficinas':
                    $('#bannerForm').attr('class', 'oficinas');
                    break;
                default:
                    $('#bannerForm').attr('class', 'espacio');
                    break;
            }

            if ($("#spaceD").val() !== 'Hogar particular' && $("#spaceD").val() !== 'Cocina') {
                $(".timeDOpt").fadeIn("slow");
                $(".timeDOpt").css("display", 'flex');
                $("#timeD").attr("required", "required");
            } else {
                $(".timeDOpt").fadeOut("slow");
                $("#timeD").removeAttr("required");
            }
        });
    }
});